// src/app/auth/auth.component.ts

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatProgressBar } from '@angular/material/progress-bar';
import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  imports: [MatProgressBar],
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  constructor(
    private route: ActivatedRoute, 
    private router: Router, 
    private loginService: LoginService
  ) {}

  async ngOnInit(): Promise<void> {
    try {
      // 1. Retrieve the 'link' parameter from query params
      this.route.queryParams.subscribe(async (params) => {
        const link = params['link'];
        
        if (!link) {
          this.redirectToSignIn('No link parameter provided in the URL');
          return;
        }

        // 2. Complete the authentication flow using LoginService
        const authResult = await this.loginService.completeAuthenticationFlow(link);
        
        if (!authResult.success) {
          this.redirectToSignIn(authResult.error || 'Cognito Authentication failed');
          return;
        }

        const { userDetails, redirectInfo: queryParams } = authResult;
        
        if (!userDetails) {
          this.redirectToSignIn('No user details received from authentication');
          return;
        }

        // Successfully navigating to dashboard
        this.router.navigate(['/dashboard']);
      });
    } catch (error) {
      console.error('An error occurred during authentication:', error);
      this.router.navigate(['/signin'], { 
        queryParams: { error: 'Authentication failed' },
        queryParamsHandling: 'merge' 
      });
    }
  }

  private redirectToSignIn(errorMsg: string) {
    console.error(errorMsg);
    this.router.navigate(['/signin'], { queryParamsHandling: 'merge' });
  }
}
